// Talotekniikan toimivuus — building scope renders the live Talotekniikka workspace
// directly (formerly Kaksonen's panel), no Yhteenveto/Havainnot/Tapahtumaloki topic tabs;
// Finding.category `fault` only (story #1037 / #1039). Zone/comfort judgment is reached via Sisäilmaolosuhteet
// (`source_type = zone`); the former Vyöhykkeiden toimivuus (`comfort`) track card on this
// lens is retired. Single-track → LensTopicSection hides the selector.
import { Boxes, Wrench } from "lucide-react";
import { EquipmentView } from "@/components/building/equipment/EquipmentView";
import { SectionPanel } from "@/components/ui/section-panel";
import { entityKindForFindingCategory } from "@/lib/entity-kind";
import { LensTopicSection, type LensTrackConfig } from "./LensTopicSection";
import { FAULT_FINDINGS_FILTER } from "./lens-topic-metrics";

const TRACKS: LensTrackConfig[] = [
  {
    id: "fault",
    filter: FAULT_FINDINGS_FILTER,
    label: "Talotekniikan toimivuus",
    trackCard: {
      icon: Wrench,
      detail:
        "IV-koneet, lämmönjako, jäähdytys — käyttäytyvätkö kuten pitäisi.",
    },
    summaryOptions: {
      okHint: "ei avoimia havaintoja",
      openHint: "avoimia havaintoja",
    },
    activityCategories: ["Konfiguraatio", "Analytiikka"],
    defaultEntityKind: entityKindForFindingCategory("fault") ?? undefined,
    findingsList: {
      ...FAULT_FINDINGS_FILTER,
      emptyMessage: "Ei avoimia havaintoja tällä radalla.",
    },
    subHeaderSuffix: "Talotekniikan toimivuus",
    overviewCopy: {
      situationCardSubtitle: (count) =>
        count === 1
          ? "1 kiinteistössä avoimia havaintoja"
          : `${count} kiinteistössä avoimia havaintoja`,
      situationCardAllDoneLabel: "Ei avoimia havaintoja",
      emptyScopeHint: "Ei kiinteistöjä valitulla rajauksella",
      tileCompleteLabel: "Kunnossa",
      mapTitle: "Talotekniikan toimivuuden kartta",
      mapSubtitle:
        "Missä talotekniikka tarvitsee eniten huomiota — pallon koko = kiinteistöjä joilla avoimia havaintoja",
      mapLegendOkLabel: "Kunnossa",
      mapLegendWarnLabel: "Tarvitsee huomiota",
    },
  },
];

export function EquipmentPerformanceSection() {
  return (
    <LensTopicSection
      eyebrow="Talotekniikan toimivuus · näkymä"
      title="Toimiiko talotekniikka niin kuin pitäisi"
      description="Toimiiko talotekniikka niin kuin pitäisi — käyttäytymisen tila."
      tracks={TRACKS}
      renderSummaryPanel={(buildingId) => (
        <SectionPanel icon={Boxes} title="Talotekniikka">
          <EquipmentView buildingId={buildingId} operator={false} />
        </SectionPanel>
      )}
    />
  );
}
